<template>
  <div class="profileIdeas ecommerce-application">
    <h1>{{ $t("profile.Products") }}</h1>
    <div v-if="loading" class="text-center font-lg">
      <b-spinner variant="primary" />
    </div>
    <div v-if="!loading && products.length == 0" class="alert alert-warning p-2 text-center">
      {{ isMyProfile ? $t("profile.product_not_created_mine") : $t("profile.product_not_created") }}
    </div>

    <section class="grid-view">
      <b-card
        class="ecommerce-card"
        :key="index"
        no-body
        id="postWidth"
        v-for="(product, index) in products"
      >
        <div class="item-img text-center ml-auto mr-auto">
          <b-link :to="`/profile/details/${product._id}`">
            <b-img
              v-if="product.files.length"
              fluid
              class="card-img-top"
              :src="product.files[0].fileUrl"
            />
          </b-link>
        </div>

        <b-card-body>
          <div class="item-wrapper">
            <div class="item-rating">
              <ul class="unstyled-list list-inline">
                <li
                  v-for="star in 5"
                  :key="star"
                  class="ratings-list-item"
                  :class="{ 'ml-25': star - 1 }"
                >
                  <feather-icon
                    icon="StarIcon"
                    size="16"
                    :class="[
                      { 'fill-current': star <= product.rating },
                      star <= product.rating ? 'text-warning' : 'text-muted',
                    ]"
                  />
                </li>
              </ul>
            </div>
            <div>
              <h6 v-if="product.price" class="item-price">${{ product.price.priceNumber }}</h6>
            </div>
          </div>
          <h6 class="item-name">
            <b-link class="text-body" :to="`/profile/details/${product._id}`">
              {{ product.name }}
            </b-link>
            <b-card-text class="item-company">
              By
              <b-link class="ml-25">
                {{ product.brand }}
              </b-link>
            </b-card-text>
          </h6>
          <b-card-text class="item-description">
            {{ product.description }}
          </b-card-text>
        </b-card-body>
      </b-card>
    </section>
  </div>
</template>
<script>
import {
  BCard,
  BCardBody,
  BCardText,
  BRow,
  BCol,
  BTable,
  BSpinner,
  BLink,
  BImg,
} from "bootstrap-vue";
import useProfile from "./useProfile.js";
export default {
  components: {
    BCard,
    BCardBody,
    BCardText,
    BRow,
    BCol,
    BTable,
    BSpinner,
    BLink,
    BImg,
  },
  data() {
    return {
      loading: false,
      products: [],
    };
  },
  setup(props, { emit }) {
    const { getProfiles } = useProfile();

    return {
      getProfiles,
    };
  },
  async mounted() {
    this.loading = true;
    this.getProfiles(this.userId, "product").then((prods) => {
      this.products = prods;
      this.loading = false;
    });
  },
  methods: {},
  props: {
    userId: {
      type: String,
    },
    isMyProfile: {
      type: Boolean,
    },
  },
};
</script>
<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>
